<ng-template #content let-modal>
  <div trapFocus style="overflow-y: auto">
    <div class="modal-header ml-auto align-items-center">
      <div id="modal-basic-title" class="modal-title">
        {{ title }}
        <select
          *ngIf="displayPeriodSelector"
          (change)="changePeriod($event.target.value)"
        >
          <option
            *ngFor="let periodId of periods()"
            value="{{ periodId }}"
            [selected]="periodId === selectedPeriod"
          >
            {{ texts?.periodText }} {{ periodId }}
          </option>
        </select>
      </div>

      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
        ngbAutofocus
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-3 text-center" id="result">
      <div class="row align-items-center">
        <div class="col-1">
          <!-- <a href="#"><img src="img/arrow-up-blue.svg" style="transform: rotate(-90deg);"></a> -->
        </div>
        <div class="col-9 col-md-10">
          <app-zonepanel [zones]="modalZones"></app-zonepanel>
        </div>
        <div class="col-1">
          <!-- <a href="#"><img src="img/arrow-up-blue.svg" style="transform: rotate(-270deg);"></a> -->
        </div>
      </div>
    </div>
    <div class="modal-footer text-uppercase">
      <!-- <span class="region">Region 1</span>&nbsp;&nbsp;&nbsp;&nbsp;Sales Revenue<br />
        <span class="keywords">#Motclé #Motclé2 #Motclé3</span> -->
    </div>
  </div>
</ng-template>
